// extracted by mini-css-extract-plugin
module.exports = {"container":"DeviceFrame_container__34D_A","content":"DeviceFrame_content__1JHJB"};